<script lang="ts">
  import LayoutGrid, { Cell } from '@smui/layout-grid';
  import { getStr, isDirectionRTL } from '../../../../common/util';
  import Icon from '../../../common/components/Icon.svelte';
  import Text from '../../../common/components/Text.svelte';
  import ExtraServiceDiscountPrice from './ExtraServiceDiscountPrice.svelte';

  export let optionName: string;
  export let optionCode: string;
  export let optionPrice;
  export let currency;
  export let active = false;
  const isRTL = isDirectionRTL();
  export let discountedPrice: string = '';
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<section on:click class="extra-service-option-section {active ? 'active' : ''}">
  <LayoutGrid>
    {#if optionName}
      <Cell spanDevices={{ desktop: 9, tablet: 4, phone: 3 }}>
        <div class="option-name">
          <Text key={optionName} />
        </div>
        {#if optionCode}
          <div class="option-code">
            <Text key={optionCode} />
          </div>
        {/if}
      </Cell>
    {/if}
    <Cell spanDevices={{ desktop: 3, tablet: 4, phone: 1 }}>
      {#if discountedPrice}
        <ExtraServiceDiscountPrice {currency} {optionPrice} {discountedPrice} />
      {:else}
        <div class="option-price" class:ar-price={isRTL}>
          {#if optionPrice && optionPrice != 0}
            {currency}
          {/if}
          <strong><Text key={optionPrice != 0 ? optionPrice : getStr('extra.pdp.freelable')} /></strong>
        </div>
      {/if}
    </Cell>
  </LayoutGrid>
  {#if active}
    <section class="active-icon">
      <Icon glyph="check" type="font" desktopSize={24} />
    </section>
  {/if}
</section>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .extra-service-option-section {
    // margin-top: 18px;
    .option-price {
      gap: 4px;
      text-align: end;
    }
    .option-name {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      color: $neutral-dark-03;
    }
    .option-price {
      color: $neutral-dark-01;
      font-weight: 400;
      font-size: 16px;
      line-height: 18px;
      // white-space: nowrap;

      @include desktop-max-width {
        color: $neutral-dark-03;
        font-size: 14px;
        line-height: 16px;
      }
    }

    .option-price {
      @include desktop-max-width {
        color: $neutral-dark-01;
      }
    }
    .ar-price {
      display: flex;
      flex-direction: row-reverse;
    }
    :global {
      .mdc-layout-grid {
        padding: 0;
        display: flex;
      }
      .mdc-layout-grid__inner {
        display: flex;
        flex-direction: column;
        border: 1px solid $secondary-gray-02;
        padding: 12px 16px;
        border-radius: 12px;
        min-width: 122px;
        align-items: flex-start;
        background: $primary-white;
        gap: 8px;
        height: 82px;
      }
    }
    &.active {
      position: relative;
      :global {
        .mdc-layout-grid__inner {
          border-color: $primary-blue;
        }
      }
      .active-icon {
        position: absolute;
        right: 8px;
        top: 4px;
      }
    }
  }
</style>
